export type SelectedInputType = {
  siteName: string;
  siteId: string;
  gatewayId: string;
  inputName: string;
  rawInputName: string;
  inputId: string;
  unit: string;
  dataType: string;
};

export type AxisItemConfig = {
  id: string;
  siteId: string;
  siteName: string;
  tagId: string;
  inputName: string;
  rawInputName: string;
  gatewayId: string;
  unit: string;
  dataType: string;
  color: string;
  aggregation: AggregationSelection | null;
  statistic: StatisticSelection | null;
  yAxisAuto?: boolean;
  yAxisFrom?: number | null;
  yAxisTo?: number | null;
};

export enum AggregationOption {
  null = 'null',
  five_min = 'five_min',
  thirty_min = 'thirty_min',
  two_hour = 'two_hour',
  one_day = 'one_day',
}

// 'Auto' is a UI-only value — resolved to the computed aggregationTypePayload before sending to the backend
export type AggregationSelection = AggregationOption | 'Auto';

export const AggregationOptionLabel: Record<AggregationSelection, string> = {
  Auto: 'Auto',
  [AggregationOption.null]: 'All data',
  [AggregationOption.five_min]: '5m',
  [AggregationOption.thirty_min]: '30m',
  [AggregationOption.two_hour]: '2h',
  [AggregationOption.one_day]: '1d',
};

export enum StatisticOption {
  AVG = 'average',
  MIN = 'min',
  MAX = 'max',
}

export type StatisticSelection = StatisticOption | 'Auto' | 'On-change' | 'Min-Average-Max';

export const StatisticOptionLabels: Record<StatisticSelection, string> = {
  Auto: 'Auto',
  'On-change': 'On-change',
  'Min-Average-Max': 'Min / Avg / Max',
  [StatisticOption.AVG]: 'Average',
  [StatisticOption.MIN]: 'Min',
  [StatisticOption.MAX]: 'Max',
};
